import * as React from "react";
import { forwardRef } from "react";
const SvgIconDownload = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 8, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M7.488 7.488a1.07 1.07 0 0 1-.684-.246L.386 1.894A1.07 1.07 0 0 1 1.756.247L7.487 5.04l5.733-4.62a1.07 1.07 0 0 1 1.508.16 1.07 1.07 0 0 1-.15 1.561L8.162 7.306a1.07 1.07 0 0 1-.674.182" }));
const ForwardRef = forwardRef(SvgIconDownload);
export { ForwardRef as ReactComponent };
